<!-- ╔═══════════════════════════════════════════╗
     ║     SECTION 7 : PROPULSE PAR MA BALISE    ║
     ╚═══════════════════════════════════════════╝ -->

<template>
  <section id="mabalise" class="py-16 py-md-15 my-md-10">
    <v-container>
      <v-row align="center">
        <v-col cols="12" md="8" order="2" order-md="1">
          <h2
            :class="[
              'font-weight-bold mb-6',
              $vuetify.breakpoint.mdAndUp ? 'display-2' : 'text-h4',
            ]"
          >
            {{ $t("section_7_mabalise_title") }}
          </h2>
          <div class="text-h6 font-weight-light mb-8">
            <p>{{ $t("section_7_mabalise_text1") }}</p>
            <p>{{ $t("section_7_mabalise_text2") }}</p>
          </div>
          <div class="d-flex flex-column flex-sm-row ga-4">
            <v-btn
              large
              depressed
              color="primary"
              :block="$vuetify.breakpoint.xsOnly"
              href="https://mabalise.be/shop/"
              target="_blank"
              >{{ $t("section_7_btn_primary") }}</v-btn
            >
            <v-btn
              large
              outlined
              color="primary"
              :block="$vuetify.breakpoint.xsOnly"
              href="https://mabalise.be/a-propos/"
              target="_blank"
              >{{ $t("section_7_btn_secondary") }}</v-btn
            >
          </div>
        </v-col>
        <v-col cols="12" md="4" order="1" order-md="2" class="text-center">
          <v-img
            :src="require('@/assets/mabalise.png')"
            max-width="300"
            class="mx-auto"
            contain
          ></v-img>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<!-- ╔═════════════════╗
     ║     SCRIPTS     ║
     ╚═════════════════╝ -->

<script>
import Vue from "vue";

export default Vue.extend({
  name: "maBalise-section",
});
</script>
